import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { type OptionDto } from "../../../autogen/bff-api";
import { inPeriodOrder } from "./extensionStatus";

export type ExtensionName = (option: OptionDto) => string;

export const useExtensionName = (options: OptionDto[]): ExtensionName => {
  const { t } = useTranslation();
  return useCallback(
    (option: OptionDto) =>
      option.name?.trim() || String(t("Extension {{number}}", { number: extensionNumber(options, option) })),
    [options, t]
  );
};

const extensionNumber = (options: OptionDto[], option: OptionDto): number =>
  inPeriodOrder(options).findIndex((other) => other.id === option.id) + 1 || options.length + 1;
